import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  workplaceSuggestions: [],
  suggestions: {
    client: [],
    user: [],
    employee: []
  },
  projectNumberReserved: false,
  workplaceLong: null,
  workplaceLat: null,
  isFormSubmitting: false,
  //zero for initial, means all should update
  rowShouldUpdate: {
    rootKey: 0,
    secondKey: 0,
    thirdKey: 0
  },
  usersData: [],
  data: {}
}


export default (state=initState, action) => {
  switch (action.type) {
    case actionConsts.GET_WORKPLACE_SUGGESTIONS_SUCCESS:
      return update(state, {
        workplaceSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.GET_SUGGESTIONS_SUCCESS:
      return update(state, {
        suggestions: {
          [action.suggestionsFor]:{
            $set: action.suggestions
          }
        }
      });
    case actionConsts.IS_PROJECTNUMBER_RESERVED_SUCCESS:
      return update(state, {
        projectNumberReserved: {
          $set: action.projectNumberReserved
        }
      });
    case actionConsts.GET_WORKPLACE_LOCATION_SUCCESS:
      return update(state, {
        workplaceLong: {
          $set: action.workplaceLong
        },
        workplaceLat: {
          $set: action.workplaceLat
        }
      });
    case actionConsts.SUBMIT_FORM_REQUEST:
      return update(state, {
        isFormSubmitting: {
          $set: true
        }
      });
    case actionConsts.SUBMIT_FORM_SUCCESS:
      return update(state, {
          $set: initState
      });
    case actionConsts.SUBMIT_FORM_FAILURE:
      return update(state, {
        isFormSubmitting: {
          $set: false
        }
    });
    case actionConsts.SET_ROW_SHOULD_UPDATE:
      return update(state, {
        rowShouldUpdate: {
          $set: action.rowShouldUpdate
        }
    });
    case actionConsts.LOAD_FORM_EDIT_PROJECT_DATA:
      return update(state, {
        data: {
          $set: action.data
        },
        usersData: {
          $set: action.users
        }
    });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/reducer.js